/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Background_Download_DescriptionInputs */

const en_mobile_background_download_description = /** @type {(inputs: Mobile_Background_Download_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow audio download in the background.`)
};

const es_mobile_background_download_description = /** @type {(inputs: Mobile_Background_Download_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permite descargar audio en segundo plano.`)
};

/**
* | output |
* | --- |
* | "Allow audio download in the background." |
*
* @param {Mobile_Background_Download_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_background_download_description = /** @type {((inputs?: Mobile_Background_Download_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Background_Download_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_background_download_description(inputs)
	return en_mobile_background_download_description(inputs)
});